import { apiUrl, isSuccess } from "./apiClient";
import httpOption from "./httpOption";

export default async function getMisc(pageName, language) {
  const options = httpOption.GET();
  options.headers["accept-language"] =
    language || options.headers["accept-language"];

  const response = await fetch(apiUrl(`/miscTable/${pageName}`), options);
  if (isSuccess(response)) {
    return response.json();
  }
  throw response;
}
